/* Écho et Pousse — interactions légères de la copie de travail.
   Sans dépendance. Les animations respectent prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pointerFine = !window.matchMedia || window.matchMedia('(hover: hover)').matches;

  function bindHero() {
    if (reduce) return;
    var stages = document.querySelectorAll('[data-ep-stage]');
    Array.prototype.forEach.call(stages, function (stage) {
      if (pointerFine) {
        stage.addEventListener('mousemove', function (e) {
          var r = stage.getBoundingClientRect();
          stage.style.setProperty('--mx', (((e.clientX - r.left) / r.width - 0.5) * 2).toFixed(3));
          stage.style.setProperty('--my', (((e.clientY - r.top) / r.height - 0.5) * 2).toFixed(3));
        }, { passive: true });
        stage.addEventListener('mouseleave', function () {
          stage.style.setProperty('--mx', '0');
          stage.style.setProperty('--my', '0');
        });
      }
      var queued = false;
      function onScroll() {
        var r = stage.getBoundingClientRect();
        var p = -r.top / Math.max(1, r.height);
        stage.style.setProperty('--sy', Math.max(-1, Math.min(1, p)).toFixed(3));
      }
      window.addEventListener('scroll', function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () { queued = false; onScroll(); });
      }, { passive: true });
      onScroll();
    });
  }

  function bindReveal() {
    var selectors = [
      '.ep-rub .ep-rub__tete',
      '.ep-rub .ep-carte',
      '.ep-section-type-bloc .ep-intro',
      '.ep-section-type-bloc .ep-carte',
      '.ep-section-type-bloc .ep-cahier-stack',
      '.ep-gardiens .ep-intro',
      '.ep-gardiens .ep-gardien',
      '.ep-halo .ep-halo__tete',
      '.ep-halo .ep-halo__scene',
      '.ep-section-lettre .ep-lettre'
    ];
    var nodes = document.querySelectorAll(selectors.join(','));
    if (!nodes.length) return;
    Array.prototype.forEach.call(nodes, function (el) { el.classList.add('ep-reveal'); });
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -5% 0px' });
    Array.prototype.forEach.call(nodes, function (el, i) {
      el.style.transitionDelay = Math.min(i % 4, 3) * 70 + 'ms';
      io.observe(el);
    });
  }

  function bindSectionScrollZoom() {
    if (reduce) return;

    var selectors = [
      '.ep-rub',
      '.ep-section-type-bloc',
      '.ep-gardiens',
      '.ep-halo',
      '.ep-section-lettre'
    ];
    var sections = Array.prototype.slice.call(document.querySelectorAll(selectors.join(',')));
    if (!sections.length) return;

    sections.forEach(function (section) {
      section.classList.add('ep-scroll-zoom');
      if (section.classList.contains('ep-rub')) section.classList.add('ep-scroll-portes');
      if (section.classList.contains('ep-gardiens')) section.classList.add('ep-scroll-gardiens');
      if (section.classList.contains('ep-halo')) section.classList.add('ep-scroll-endormi');
      if (section.classList.contains('ep-section-lettre')) section.classList.add('ep-scroll-lettre');
      if (section.querySelector && section.querySelector('.ep-cahier-stack')) section.classList.add('ep-scroll-cahier');
      if (section.querySelector && section.querySelector('.ep-copous-rail')) section.classList.add('ep-scroll-copous');
      if (section.classList.contains('ep-section-type-bloc') &&
          !section.classList.contains('ep-scroll-cahier') &&
          !section.classList.contains('ep-scroll-copous')) {
        section.classList.add('ep-scroll-jardin');
      }
    });

    var scheduled = false;
    function update() {
      scheduled = false;
      var vh = window.innerHeight || document.documentElement.clientHeight || 800;
      var viewportCenter = vh / 2;

      sections.forEach(function (section) {
        var r = section.getBoundingClientRect();
        var center = r.top + r.height / 2;
        var distance = Math.abs(center - viewportCenter);
        var p = 1 - Math.min(1, distance / (vh * .82));

        var isCahier = section.classList.contains('ep-scroll-cahier');
        var isGardiens = section.classList.contains('ep-scroll-gardiens');
        var isPortes = section.classList.contains('ep-scroll-portes');

        var minScale = isCahier ? .86 : (isGardiens ? .90 : (isPortes ? .92 : .90));
        var maxScale = isCahier ? 1.035 : 1.018;
        var maxY = isCahier ? 72 : (isGardiens ? 60 : 52);

        var focus = Math.pow(Math.max(0, Math.min(1, p)), .72);
        var scale = minScale + (maxScale - minScale) * focus;
        var y = maxY * (1 - focus);
        var opacity = .62 + .38 * focus;

        section.style.setProperty('--ep-focus', focus.toFixed(3));
        section.style.setProperty('--ep-scroll-scale', scale.toFixed(3));
        section.style.setProperty('--ep-scroll-y', y.toFixed(1) + 'px');
        section.style.setProperty('--ep-scroll-opacity', opacity.toFixed(3));
        section.style.setProperty('--ep-shadow', focus.toFixed(3));
      });
    }

    function requestUpdate() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive:true });
    window.addEventListener('resize', requestUpdate, { passive:true });
    update();
  }

  function bindMagicTitles() {
    var selectors = [
      '.ep-rub__titre',
      '.ep-merv__titre',
      '.ep-section-type-bloc > .ep-contenu > .ep-intro .ep-titre-2',
      '.ep-gardiens > .ep-contenu > .ep-intro .ep-titre-2',
      '.ep-halo__titre',
      '.ep-section-lettre .ep-lettre > .ep-titre-2'
    ];
    var titles = Array.prototype.slice.call(document.querySelectorAll(selectors.join(',')));
    titles = titles.filter(function (title) {
      var section = title.closest('section');
      return !(section && section.querySelector('.ep-copous-rail'));
    });
    if (!titles.length) return;

    titles.forEach(function (title) {
      if (title.dataset.epTitleReady || title.dataset.epLettersReady) return;
      title.dataset.epTitleReady = '1';
      title.classList.add('ep-title-magic');

      var section = title.closest ? title.closest('section') : null;
      if (title.classList.contains('ep-merv__titre')) title.classList.add('ep-title-magic--featured');
      if (section && section.classList.contains('ep-gardiens')) title.classList.add('ep-title-magic--featured','ep-title-magic--leaf');
      if (section && section.querySelector && section.querySelector('.ep-cahier-stack')) title.classList.add('ep-title-magic--cahier');
      if (section && section.classList.contains('ep-halo')) title.classList.add('ep-title-magic--night');
      if (section && section.classList.contains('ep-theme-earth')) title.classList.add('ep-title-magic--earth');
      if (section && section.classList.contains('ep-theme-paper')) title.classList.add('ep-title-magic--paper');
      if (section && section.classList.contains('ep-theme-living')) title.classList.add('ep-title-magic--living');
      if (section && section.classList.contains('ep-theme-spark')) title.classList.add('ep-title-magic--spark');
      if (section && section.classList.contains('ep-theme-letter')) title.classList.add('ep-title-magic--warm');

      var content = title.textContent || '';
      var text = content.trim();
      if (!text) return;

      title.textContent = '';
      text.split(/\s+/).forEach(function (word, i, arr) {
        var span = document.createElement('span');
        span.className = 'ep-title-word';
        span.style.setProperty('--ep-word-i', i);
        span.textContent = word;
        title.appendChild(span);
        if (i < arr.length - 1) title.appendChild(document.createTextNode(' '));
      });
    });

    if (reduce || !('IntersectionObserver' in window)) {
      titles.forEach(function (title) { title.classList.add('is-title-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-title-visible');
        io.unobserve(entry.target);
      });
    }, { threshold:.30, rootMargin:'0px 0px -4% 0px' });

    titles.forEach(function (title) { io.observe(title); });
  }

  function bindCharacterHighlights() {
    var hero = document.querySelector('.ep-hero__title-text');
    if (hero && hero.dataset.epHeroReady !== '1') {
      hero.dataset.epHeroReady = '1';
      hero.classList.add('ep-hero-title-animated');
      var heroText = (hero.textContent || '').trim();
      if (heroText) {
        hero.textContent = '';
        heroText.split(/\s+/).forEach(function (word, i, arr) {
          var span = document.createElement('span');
          span.className = 'ep-hero-title-word';
          span.style.setProperty('--ep-hero-word-i', i);
          span.textContent = word;
          hero.appendChild(span);
          if (i < arr.length - 1) hero.appendChild(document.createTextNode(' '));
        });
        if (reduce || !('IntersectionObserver' in window)) {
          hero.classList.add('is-hero-title-visible');
        } else {
          var heroIo = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              hero.classList.add('is-hero-title-visible');
              heroIo.unobserve(hero);
            });
          }, { threshold:.42, rootMargin:'0px 0px -6% 0px' });
          heroIo.observe(hero);
        }
      }
    }

    var names = Array.prototype.slice.call(document.querySelectorAll('.ep-gardien__nom, .ep-gardien__ami-nom'));
    names.forEach(function (name) {
      if (name.dataset.epNameReady === '1') return;
      name.dataset.epNameReady = '1';
      name.classList.add('ep-name-magic');

      var text = (name.textContent || '').trim();
      if (!text) return;
      name.textContent = '';
      Array.prototype.forEach.call(text, function (char, i) {
        var span = document.createElement('span');
        span.className = 'ep-name-letter';
        span.style.setProperty('--ep-letter-i', i);
        span.textContent = char;
        name.appendChild(span);
      });
    });

    if (reduce || !('IntersectionObserver' in window)) {
      names.forEach(function (name) { name.classList.add('is-name-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-name-visible');
        io.unobserve(entry.target);
      });
    }, { threshold:.55, rootMargin:'0px 0px -6% 0px' });

    names.forEach(function (name) { io.observe(name); });
  }

  function bindMerveilles() {
    var scenes = document.querySelectorAll('[data-ep-merv-scene]');
    Array.prototype.forEach.call(scenes, function (scene) {
      var track = scene.querySelector('[data-ep-merv-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.ep-merv__carte'));
      if (!cards.length) return;

      function closestIndex() {
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, dist = Infinity;
        cards.forEach(function (card, i) {
          var c = card.offsetLeft + card.offsetWidth / 2;
          var d = Math.abs(c - center);
          if (d < dist) { dist = d; best = i; }
        });
        return best;
      }

      var dots = Array.prototype.slice.call(scene.parentNode.querySelectorAll('[data-ep-merv-dot]'));

      function paint(index) {
        cards.forEach(function (card, i) {
          card.classList.toggle('is-active', i === index);
          card.classList.toggle('is-prev', i === index - 1);
          card.classList.toggle('is-next', i === index + 1);
          if (i !== index) {
            card.style.setProperty('--ep-rx', '0deg');
            card.style.setProperty('--ep-ry', '0deg');
          }
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      function centerCard(index, smooth) {
        index = Math.max(0, Math.min(cards.length - 1, index));
        var card = cards[index];
        var left = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
        track.scrollTo({ left: left, behavior: smooth && !reduce ? 'smooth' : 'auto' });
        paint(index);
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          paint(closestIndex());
        });
      }, { passive: true });

      var prev = scene.parentNode.querySelector('[data-ep-merv-prev]');
      var next = scene.parentNode.querySelector('[data-ep-merv-next]');
      if (prev) prev.addEventListener('click', function () { centerCard(closestIndex() - 1, true); });
      if (next) next.addEventListener('click', function () { centerCard(closestIndex() + 1, true); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { centerCard(i, true); });
      });

      cards.forEach(function (card) {
        card.addEventListener('pointermove', function (e) {
          var r = card.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width;
          var py = (e.clientY - r.top) / r.height;
          card.style.setProperty('--ep-x', (px * 100).toFixed(1) + '%');
          card.style.setProperty('--ep-y', (py * 100).toFixed(1) + '%');
          if (!reduce && pointerFine && card.classList.contains('is-active')) {
            card.style.setProperty('--ep-ry', ((px - .5) * 5).toFixed(2) + 'deg');
            card.style.setProperty('--ep-rx', ((.5 - py) * 4).toFixed(2) + 'deg');
          }
        }, { passive: true });
        card.addEventListener('pointerleave', function () {
          card.style.setProperty('--ep-rx', '0deg');
          card.style.setProperty('--ep-ry', '0deg');
        }, { passive: true });
      });

      var initial = 0;
      window.requestAnimationFrame(function () { centerCard(initial, false); });
    });
  }

  function bindCTAAttraction() {
    var selectors = [
      '.ep-bouton',
      '.ep-actions .ep-btn',
      '.ep-gardien__mission-btn',
      '.ep-carte__lien'
    ];
    var ctas = Array.prototype.slice.call(document.querySelectorAll(selectors.join(',')));
    if (!ctas.length) return;

    ctas.forEach(function (cta, i) {
      cta.classList.add('ep-cta-magic');
      cta.style.setProperty('--ep-cta-delay', ((i % 3) * .42).toFixed(2) + 's');

      var label = (cta.textContent || '').trim().toLowerCase();
      var section = cta.closest ? cta.closest('section') : null;

      if (cta.classList.contains('ep-bouton')) {
        if (label.indexOf('faire sa terre') !== -1 || label.indexOf('terre') !== -1) {
          cta.classList.add('ep-cta-illustrated','ep-cta-earth');
          if (section) section.classList.add('ep-theme-earth');
        } else if (label.indexOf('cahier') !== -1 || label.indexOf('coloriage') !== -1) {
          cta.classList.add('ep-cta-illustrated','ep-cta-paper');
          if (section) section.classList.add('ep-theme-paper');
        } else if (label.indexOf('copous') !== -1) {
          cta.classList.add('ep-cta-illustrated','ep-cta-living');
          if (section) section.classList.add('ep-theme-living');
        } else if (label.indexOf('puzzle') !== -1 || label.indexOf('tréflor') !== -1 || label.indexOf('treflor') !== -1) {
          cta.classList.add('ep-cta-illustrated','ep-cta-spark');
          if (section) section.classList.add('ep-theme-spark');
        } else if (label.indexOf("m'abonne") !== -1 || label.indexOf('abonne') !== -1) {
          cta.classList.add('ep-cta-illustrated','ep-cta-letter');
          if (section) section.classList.add('ep-theme-letter');
        }
      }
    });

    if (reduce || !('IntersectionObserver' in window)) {
      ctas.forEach(function (cta) { cta.classList.add('is-cta-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-cta-visible');
        io.unobserve(entry.target);
      });
    }, { threshold:.55, rootMargin:'0px 0px -8% 0px' });

    ctas.forEach(function (cta) { io.observe(cta); });
  }

  function bindTapFeedback() {
    var selector = '.ep-bouton,.ep-btn,.ep-hero__sound,.ep-nav__cta,.ep-menu__lien,.ep-icone,.ep-gardien__mission-btn,.ep-carte__lien';
    var items = document.querySelectorAll(selector);
    Array.prototype.forEach.call(items, function (el) {
      el.addEventListener('pointerdown', function () {
        el.classList.add('ep-is-pressed');
        window.setTimeout(function () { el.classList.remove('ep-is-pressed'); }, 180);
      }, { passive:true });
    });
  }

  function bindMissions() {
    var buttons = document.querySelectorAll('.ep-gardien__mission-btn');
    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener('click', function () {
        var panel = button.nextElementSibling;
        if (!panel || !panel.classList.contains('ep-gardien__mission')) return;
        var open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
        button.textContent = open ? 'Ma mission du jour' : 'Refermer la mission';
      });
    });
  }

  function init() {
    bindHero();
    bindReveal();
    bindSectionScrollZoom();
    bindCTAAttraction();
    bindMagicTitles();
    bindCharacterHighlights();
    bindMerveilles();
    bindMissions();
    bindTapFeedback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var cards = [];
  var titles = [];
  var rails = [];
  var pending = false;
  var titleObserver = null;
  var cardObserver = null;
  function makeLetters(title) {
    if (title.dataset.epLettersReady || title.dataset.epTitleReady) return;
    var text = title.textContent;
    if (!text || title.querySelector('a, img, button')) return;
    title.dataset.epLettersReady = '1';
    title.classList.add('ep-letter-title');
    title.setAttribute('aria-label', text);
    var fragment = document.createDocumentFragment();
    var index = 0;
    text.split(/(\s+)/).forEach(function (part) {
      if (/^\s+$/.test(part)) {
        fragment.appendChild(document.createTextNode(part));
        return;
      }
      var word = document.createElement('span');
      word.className = 'ep-letter-word';
      Array.from(part).forEach(function (letter) {
        var span = document.createElement('span');
        span.className = 'ep-letter';
        span.style.setProperty('--ep-letter-delay', Math.min(index * 32, 850) + 'ms');
        span.textContent = letter;
        word.appendChild(span);
        index += 1;
      });
      fragment.appendChild(word);
    });
    title.replaceChildren(fragment);
    titles.push(title);
    if (!reduced.matches && titleObserver) titleObserver.observe(title);
  }

  function makeWords(title) {
    if (title.dataset.epLettersReady || title.dataset.epTitleReady) return;
    var text = title.textContent;
    if (!text || title.querySelector('a, img, button')) return;
    title.dataset.epLettersReady = '1';
    title.classList.add('ep-soft-title');
    var fragment = document.createDocumentFragment();
    var index = 0;
    text.split(/(\s+)/).forEach(function (part) {
      if (/^\s+$/.test(part)) {
        fragment.appendChild(document.createTextNode(part));
      } else {
        var span = document.createElement('span');
        span.className = 'ep-soft-word';
        span.style.setProperty('--ep-letter-delay', Math.min(index * 45, 270) + 'ms');
        span.textContent = part;
        fragment.appendChild(span);
        index += 1;
      }
    });
    title.replaceChildren(fragment);
    titles.push(title);
    if (!reduced.matches && titleObserver) titleObserver.observe(title);
  }

  function prepareCard(card) {
    if (card.dataset.epDepthReady) return;
    card.dataset.epDepthReady = '1';
    card.classList.add('ep-depth-card');
    if (card.querySelector('.ep-enfant__intitule')) card.classList.add('ep-ft-child');
    if (card.querySelector('.ep-mesure')) card.classList.add('ep-ft-measure');
    var quiet = !card.closest('.ep-copous-rail') && !card.querySelector('.ep-mesure');
    if (quiet) {
      card.classList.add('ep-depth-static');
      if (!reduced.matches && cardObserver) cardObserver.observe(card);
      if (!card.closest('.ep-ft')) return;
    }
    if (!quiet) cards.push(card);
    var release = function () { card.classList.remove('ep-depth-pressed'); };
    card.addEventListener('pointerdown', function (event) {
      if (reduced.matches || event.target.closest('a,button,input,select,textarea')) return;
      card.classList.add('ep-depth-pressed');
    }, { passive: true });
    ['pointerup', 'pointercancel', 'pointerleave', 'pointermove'].forEach(function (event) {
      card.addEventListener(event, release, { passive: true });
    });
  }
  function updateDepth() {
    pending = false;
    if (reduced.matches) return;
    var height = window.innerHeight;
    var narrow = window.innerWidth < 600;
    var values = cards.filter(function (card) { return card.isConnected; }).map(function (card) {
      var rect = card.getBoundingClientRect();
      if (rect.bottom < -80 || rect.top > height + 80) return null;
      var longCard = card.offsetHeight > height * .6;
      var point = longCard ? rect.top + Math.min(100, rect.height * .15) : rect.top + rect.height / 2;
      var progress = Math.max(0, Math.min(1, (height * .96 - point) / (height * .5)));
      var rail = card.closest('.ep-depth-rail');
      var earth = !!card.closest('.ep-ft');
      var scale = earth ? .92 + .08 * progress : .94 + .06 * progress;
      if (rail) {
        var rr = rail.getBoundingClientRect();
        var distance = Math.abs(rect.left + rect.width / 2 - (rr.left + rr.width / 2));
        var focus = Math.max(0, 1 - distance / (rr.width * .7));
        scale *= .97 + (narrow ? .045 : .055) * focus;
      }
      return { card: card, scale: scale, y: (1 - progress) * 20 - progress * 3, rx: (1 - progress) * 4 };
    });
    values.forEach(function (value) {
      if (!value) return;
      value.card.style.setProperty('--ep-depth-scale', value.scale.toFixed(3));
      value.card.style.setProperty('--ep-depth-y', value.y.toFixed(1) + 'px');
      value.card.style.setProperty('--ep-depth-rx', value.rx.toFixed(1) + 'deg');
    });
  }
  function requestDepth() {
    if (pending || reduced.matches) return;
    pending = true;
    window.requestAnimationFrame(updateDepth);
  }
  function init() {
    if (!titleObserver && 'IntersectionObserver' in window) {
      titleObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ep-letters-arrived', 'is-title-visible');
          titleObserver.unobserve(entry.target);
        });
      }, { threshold: .15, rootMargin: '0px 0px -6% 0px' });
    }
    if (!cardObserver && 'IntersectionObserver' in window) {
      cardObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ep-depth-arrived');
          cardObserver.unobserve(entry.target);
        });
      }, { threshold: .08, rootMargin: '0px 0px -3% 0px' });
    }
    var cp = document.querySelector('.ep-cp');
    if (cp) {
      cp.querySelectorAll('.ep-intro .ep-titre-2, h2.ep-titre-2').forEach(makeLetters);
      cp.querySelectorAll('.ep-copou').forEach(prepareCard);
    }
    var root = document.querySelector('.ep-ft');
    if (root) {
      root.querySelectorAll('.ep-titre-2').forEach(makeLetters);
      root.querySelectorAll('.ep-carte__titre,.ep-saison,.ep-mesure,.ep-enfant__intitule').forEach(makeLetters);
      root.querySelectorAll('.ep-carte').forEach(function (card) {
        var siblings = Array.prototype.filter.call(card.parentElement.children, function (item) { return item.classList.contains('ep-carte'); });
        card.style.setProperty('--ep-ft-delay', Math.min(siblings.indexOf(card), 3) * 65 + 'ms');
        prepareCard(card);
      });
      root.querySelectorAll('.ep-boutons .ep-bouton').forEach(function (cta) { cta.classList.add('ep-depth-cta'); });
    }
    document.querySelectorAll('.ep-copous-rail').forEach(function (rail) {
      if (rails.indexOf(rail) !== -1) return;
      rails.push(rail);
      rail.classList.add('ep-depth-rail');
      rail.querySelectorAll('.ep-carte').forEach(prepareCard);
      var section = rail.closest('section');
      if (section) {
        var heading = section.querySelector('.ep-intro .ep-titre-2');
        if (heading) {
          heading.classList.add('ep-title-magic', 'ep-title-magic--living');
          makeLetters(heading);
        }
        section.querySelectorAll('.ep-bouton').forEach(function (cta) { cta.classList.add('ep-depth-cta'); });
      }
      rail.addEventListener('scroll', requestDepth, { passive: true });
    });
    requestDepth();
  }
  window.addEventListener('scroll', requestDepth, { passive: true });
  window.addEventListener('resize', requestDepth, { passive: true });
  function motionChanged() {
    if (reduced.matches) {
      cards.forEach(function (card) { card.classList.remove('ep-depth-pressed'); });
    } else {
      titles.forEach(function (title) {
        if (titleObserver && !title.classList.contains('ep-letters-arrived')) titleObserver.observe(title);
      });
      requestDepth();
    }
  }
  if (reduced.addEventListener) reduced.addEventListener('change', motionChanged);
  else if (reduced.addListener) reduced.addListener(motionChanged);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
